export const termsUrl = 'https://www.shelterzoom.com/legal';
export const facebookUrl = 'https://facebook.com/ShelterZoom/';
export const twitterUrl = 'https://twitter.com/shelterzoom';
export const linkedinUrl = 'https://linkedin.com/company/shelterzoom/';
export const instagramUrl = 'https://www.instagram.com/shelterzoom/';
